(() => {
  if (window.__gearfullCartDrawerHelpers) return;
  window.__gearfullCartDrawerHelpers = true;

  window.gearfullUpdateCartBubble = async () => {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink || !window.routes?.cart_url) return;

    try {
      const response = await fetch(`${window.routes.cart_url}.js`, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) return;

      const cart = await response.json();
      const count = Number(cart.item_count || 0);
      let bubble = cartLink.querySelector('.cart-count-bubble');

      if (count < 1) {
        if (bubble) bubble.remove();
        return;
      }

      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        cartLink.appendChild(bubble);
      }

      bubble.innerHTML = `${count < 100 ? `<span aria-hidden="true">${count}</span>` : ''}<span class="visually-hidden">${count} items in cart</span>`;
    } catch (error) {
      console.error(error);
    }
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    try {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        setTimeout(() => window.gearfullUpdateCartBubble?.(), 80);
      });
    } catch (error) {
      console.error(error);
    }
  }
})();

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        if (this.variantIdInput) this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;

        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      get cart() {
        return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      }

      get cartDrawer() {
        return document.querySelector('cart-drawer');
      }

      get spinner() {
        return this.querySelector('.loading__spinner');
      }

      get variantIdInput() {
        return this.form ? this.form.querySelector('[name=id]') : null;
      }

      clearCartDrawerErrors() {
        ['#CartDrawer-CartErrors', '#cart-errors'].forEach((selector) => {
          const element = document.querySelector(selector);
          if (element) element.textContent = '';
        });
      }

      safeMeasureFromEvent(name, event) {
        if (typeof CartPerformance !== 'undefined' && typeof CartPerformance.measureFromEvent === 'function') {
          try {
            CartPerformance.measureFromEvent(name, event);
          } catch (error) {
            console.error(error);
          }
        }
      }

      buildFormData() {
        const formData = new FormData(this.form);
        const cart = this.cart;

        if (cart && typeof cart.getSectionsToRender === 'function') {
          const sectionIds = cart
            .getSectionsToRender()
            .map((section) => section.id)
            .filter(Boolean);

          formData.append('sections', sectionIds.join(','));
          formData.append('sections_url', window.location.pathname);

          if (typeof cart.setActiveElement === 'function') {
            cart.setActiveElement(document.activeElement);
          }
        } else {
          formData.append('sections', 'cart-drawer,cart-icon-bubble');
          formData.append('sections_url', window.location.pathname);
        }

        return formData;
      }

      async addToCart(formData) {
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        const response = await fetch(`${routes.cart_add_url}`, config);
        const parsedState = await response.json().catch(() => ({}));

        if (!response.ok || parsedState.status) {
          throw new Error(
            parsedState.description || parsedState.message || window.cartStrings?.error || 'Could not add this product to the cart.'
          );
        }

        return parsedState;
      }

      getSectionElementFromHtml(html, selector) {
        if (!html) return null;
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
      }

      replaceCartIconBubble(sectionHtml) {
        const currentBubble = document.querySelector('#cart-icon-bubble');
        if (!currentBubble || !sectionHtml) return;

        const incomingBubble = this.getSectionElementFromHtml(sectionHtml, '#cart-icon-bubble');
        if (incomingBubble) currentBubble.innerHTML = incomingBubble.innerHTML;
      }

      replaceCartDrawer(sectionHtml) {
        const currentDrawer = document.querySelector('#CartDrawer');
        if (!currentDrawer || !sectionHtml) return false;

        const incomingDrawer = this.getSectionElementFromHtml(sectionHtml, '#CartDrawer');
        if (!incomingDrawer) return false;

        currentDrawer.innerHTML = incomingDrawer.innerHTML;
        this.rebindCartDrawerOverlay();
        this.clearCartDrawerErrors();
        return true;
      }

      rebindCartDrawerOverlay() {
        const cartDrawer = this.cartDrawer;
        if (!cartDrawer || typeof cartDrawer.close !== 'function') return;

        const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
      }

      async refreshCartDrawerFromSection() {
        try {
          const response = await fetch(`${routes.cart_url}?section_id=cart-drawer`, {
            credentials: 'same-origin',
            cache: 'no-store',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
          });

          if (!response.ok) return false;

          const sectionHtml = await response.text();
          return this.replaceCartDrawer(sectionHtml);
        } catch (error) {
          console.error(error);
          return false;
        }
      }

      openCartDrawer() {
        const cartDrawer = this.cartDrawer;
        if (!cartDrawer) return;

        cartDrawer.classList.remove('is-empty');
        this.clearCartDrawerErrors();

        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open(this.submitButton || document.activeElement);
          return;
        }

        cartDrawer.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');
      }

      async renderCartAfterAdd(parsedState) {
        this.clearCartDrawerErrors();

        try {
          let drawerUpdated = false;

          if (parsedState.sections) {
            drawerUpdated = this.replaceCartDrawer(parsedState.sections['cart-drawer']);
            this.replaceCartIconBubble(parsedState.sections['cart-icon-bubble']);
          }

          if (!drawerUpdated) {
            await this.refreshCartDrawerFromSection();
          }

          await window.gearfullUpdateCartBubble?.();
          this.openCartDrawer();
          this.clearCartDrawerErrors();
          setTimeout(() => this.clearCartDrawerErrors(), 150);
        } catch (error) {
          console.error(error);
          await this.refreshCartDrawerFromSection();
          await window.gearfullUpdateCartBubble?.();
          this.openCartDrawer();
          this.clearCartDrawerErrors();
          setTimeout(() => this.clearCartDrawerErrors(), 150);
        }
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.clearCartDrawerErrors();
        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');
        this.spinner?.classList.remove('hidden');

        let formData;

        try {
          formData = this.buildFormData();
          const parsedState = await this.addToCart(formData);

          this.error = false;
          await this.renderCartAfterAdd(parsedState);
        } catch (error) {
          console.error(error);
          this.error = true;
          this.handleErrorMessage(error && error.message ? error.message : window.cartStrings?.error);

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            try {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData ? formData.get('id') : null,
                errors: error && error.message ? error.message : window.cartStrings?.error,
                message: error && error.message ? error.message : window.cartStrings?.error,
              });
            } catch (publishError) {
              console.error(publishError);
            }
          }
        } finally {
          this.submitButton.classList.remove('loading');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.spinner?.classList.add('hidden');
          this.safeMeasureFromEvent('add:user-action', evt);
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }
    }
  );
}
